import { noPreferenceReducedMotion } from '../../functions/reducedMotion';
(function () {
    const accordionItems = document.querySelectorAll('[data-accordion-item]');
    const openClass = 'spv-accordion__item--open';
    const ease = 'circ.inOut';
    const duration = noPreferenceReducedMotion ? 0.3 : 0;
    if (!accordionItems)
        return;
    const handleAccordionToggleAnimated = (gsap, accordionItem, collapsibleElement, clickTarget) => {
        if (accordionItem.classList.contains(openClass)) {
            gsap.to(collapsibleElement, {
                duration: duration,
                height: 0,
                ease: ease,
                onComplete: () => {
                    accordionItem.classList.remove(openClass);
                    clickTarget.ariaExpanded = 'false';
                    collapsibleElement.setAttribute('hidden', 'until-found');
                },
            });
        }
        else {
            clickTarget.ariaExpanded = 'true';
            collapsibleElement.hidden = false;
            accordionItem.classList.add(openClass);
            gsap.set(collapsibleElement, { height: 'auto' });
            gsap.from(collapsibleElement, {
                duration: duration,
                height: 0,
                ease: ease,
                onComplete: () => {
                    collapsibleElement.style.height = 'auto';
                },
            });
        }
    };
    const handleAccordionTogglePlain = (accordionItem, collapsibleElement, clickTarget) => {
        if (accordionItem.classList.contains(openClass)) {
            accordionItem.classList.remove(openClass);
            clickTarget.ariaExpanded = 'false';
            collapsibleElement.setAttribute('hidden', 'until-found');
            collapsibleElement.style.height = '0';
        }
        else {
            clickTarget.ariaExpanded = 'true';
            collapsibleElement.hidden = false;
            accordionItem.classList.add(openClass);
            collapsibleElement.style.height = 'auto';
        }
    };
    accordionItems.forEach(accordionItem => {
        const clickTarget = accordionItem.querySelector('[data-accordion-button]');
        const collapsibleElement = accordionItem.querySelector('[data-accordion-content]');
        if (noPreferenceReducedMotion) {
            import('gsap').then(({ gsap }) => {
                collapsibleElement.addEventListener('beforematch', () => handleAccordionToggleAnimated(gsap, accordionItem, collapsibleElement, clickTarget));
                clickTarget.onclick = function () {
                    handleAccordionToggleAnimated(gsap, accordionItem, collapsibleElement, clickTarget);
                };
            });
        }
        else {
            collapsibleElement.addEventListener('beforematch', () => handleAccordionTogglePlain(accordionItem, collapsibleElement, clickTarget));
            clickTarget.onclick = function () {
                handleAccordionTogglePlain(accordionItem, collapsibleElement, clickTarget);
            };
        }
    });
})();
//# sourceMappingURL=accordion.js.map